import { isAfter } from "date-fns";
import { definedsDates } from "../partials/Calendar/config";

const resultsPerPage = 50;

const monthsRange = 6;

const actualDate = new Date();
const options = [
    {
        label: "Hoje",
        range: () => ({
            startDate: definedsDates.startOfToday,
            endDate: definedsDates.endOfToday
        })
    },
    {
        label: "Últimos 7 Dias",
        range: () => ({
            startDate: definedsDates.startOfLastSevenDay,
            endDate: definedsDates.endOfToday
        })
    },
    {
        label: "Últimos 30 Dias",
        range: () => ({
            startDate: definedsDates.startOfLastThirtyDay,
            endDate: definedsDates.endOfToday
        })
    },
    {
        label: "Últimos 90 Dias",
        range: () => ({
            startDate: definedsDates.startOfLastThirtyDay,
            endDate: definedsDates.endOfToday
        })
    },
    {
        label: "Esta Semana",
        range: () => ({
            startDate: definedsDates.startOfWeek,
            endDate: isAfter(definedsDates.endOfWeek, actualDate)
                ? actualDate
                : definedsDates.endOfWeek
        })
    },
    {
        label: "Última Semana",
        range: () => ({
            startDate: definedsDates.startOfLastWeek,
            endDate: definedsDates.endOfLastWeek
        })
    },
    {
        label: "Mês Atual",
        range: () => ({
            startDate: definedsDates.startOfMonth,
            endDate: isAfter(definedsDates.endOfMonth, actualDate)
                ? actualDate
                : definedsDates.endOfMonth
        })
    },
    {
        label: "Último Mês",
        range: () => ({
            startDate: definedsDates.startOfLastMonth,
            endDate: definedsDates.endOfLastMonth
        })
    },
    {
        label: "Últimos 3 Meses",
        range: () => ({
            startDate: definedsDates.startOfLast3Months,
            endDate: definedsDates.endOfLastMonth
        })
    },
    {
        label: "Últimos 6 Meses",
        range: () => ({
            startDate: definedsDates.startOfLast6Months,
            endDate: definedsDates.endOfLastMonth
        })
    },
];

export {
    resultsPerPage,
    monthsRange,
    options
}